import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { EveReportingBarChartWidget } from '../../bar-chart-widget/bar-chart-widget.component';

import { Color/*, colorSets */} from '@swimlane/ngx-charts/lib/utils/color-sets'
import { ScaleType } from '@swimlane/ngx-charts';
import { EveReportingFuelGaugeChartWidget, gaugeThresholdSettings } from '../fuel-gauge-chart-widget.component';
import { MatSliderChange } from '@angular/material/slider';
import { GraphClickEventTypes } from '../../widget.component';
import { EveReportingWidgetDataSourceType } from '../../widget-menu-settings/widget-datasource/widget-datasource.component';

@Component({
  selector: 'fuel-gauge-chart-widget-menu-settings',
  templateUrl: 'fuel-gauge-chart-widget-menu-settings.component.html',
  styleUrls: ['./fuel-gauge-chart-widget-menu-settings.component.css'],
  viewProviders: [
    { provide: ControlContainer, useExisting: NgForm }
  ]
})
export class FuelGaugeChartWidgetMenuSettingsComponent implements OnInit {

  @Input()
  widget?: EveReportingFuelGaugeChartWidget = null;

  graphClickEventTypes = GraphClickEventTypes;

  enumKeys: any;  

  color: '#ff0000';

  thresholdSettings: gaugeThresholdSettings[] = [];

  constructor(

  ) {


  }

  ngOnInit(): void {
    this.enumKeys = Object.values(GraphClickEventTypes).filter(isNaN);
    if (this.widget.onClick == null) this.widget.onClick = {
      type: GraphClickEventTypes.none
    };
    if (this.widget.thresholdSettings == null) this.widget.thresholdSettings = [];

    //TODO: this isnt right
    //if (this.widget.dataSource == null) this.widget.dataSource = {
    //  type: EveReportingWidgetDataSourceType.None
    //};

    if (this.widget.dataSource?.type != EveReportingWidgetDataSourceType.EveSingleChart) this.widget.dataSource = {
      type: EveReportingWidgetDataSourceType.EveSingleChart
    };
  }



  addNewThreshold() {
    const newThreshold: gaugeThresholdSettings = { minimumValue: 0, colour: 'rgba(255, 255, 255, 1)', showInBackground: false};
    this.widget.thresholdSettings.push(newThreshold);
  }

  removeThresholdSetting(setting) {
    var indexOf = this.widget.thresholdSettings.indexOf(setting);
    console.log(indexOf);
    if (indexOf > -1) {
      this.widget.thresholdSettings.splice(indexOf, 1); 
    }
  }

  onThicknessSliderChange(event: MatSliderChange) {
    this.widget.thickness = event.value;
  }

  onAnimationDurationSliderChange(event: MatSliderChange) {
    this.widget.animationDuration = event.value;
  }
}





